/**
 * Other: Discounted MRP × Units × Timeline × Timeslot (timeslot optional).
 */
import { timeslotMultiplier } from './multipliers';

export function calculateOtherTotal(variant, selection) {
  const discountedPrice = Number(variant?.DiscountedPrice) || 0;
  const units = Number(selection?.unitsToBebought) || 1;
  const timelineQty = Number(selection?.timelineToBought) || 1;
  const selectedSeconds = Number(selection?.BoughtSeconds) || 0;
  const minTimeslotSeconds = Number(variant?.minTimeslotSeconds) > 0 ? Number(variant.minTimeslotSeconds) : 1;

  const tMult = timelineQty;
  const sMult = selectedSeconds > 0 ? timeslotMultiplier(selectedSeconds, minTimeslotSeconds) : 1;
  return discountedPrice * units * tMult * sMult;
}
